
import router from "@/router";
import { showInformationSnackbar } from "@/utils/snackbarUtils";
import BaseView from "./BaseView.vue";

export default class BaseAuthenticatedView extends BaseView {
  protected async mounted() {
    await super.mounted();
  }

  protected clearExistingAuthorizationToken() {
    let hasOutdatedAuthorizationToken: boolean =
      this.$store.state.authorization.authorizationToken != undefined;

    super.clearExistingAuthorizationToken();
    this.$store.dispatch("resetState");
    this.$store.commit("SET_IS_AUTHORIZED", false);

    if (
      !["/login", "/forgot-password", "/sign-up"].includes(
        this.$router.currentRoute.path
      )
    ) {
      showInformationSnackbar(
        hasOutdatedAuthorizationToken
          ? "Your in-app session has expired. Redirecting to login..."
          : "Redirecting to login..."
      );
      window.location = window.location.origin as any
    }
  }
}
